import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { IconPosition } from '../models/link-icon.enum';
import { LinkTarget } from '../models/link-target';

@Component({
  selector: 'nibtravel-link-icon',
  templateUrl: './link-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LinkIconComponent {
  /** Expose the IconPosition enum for template ngSwitch */
  IconPosition = IconPosition;

  @HostBinding('class') hostClass = 'link-icon-button';
  @HostBinding() tabindex = -1;

  @Input()
  @HostBinding('id')
  hostId!: string;

  /** The id of e2e tag */
  @Input() e2eId: string | null = null;

  /** The name of link  */
  @Input() name!: string;

  /** The icon to be displayed. Check IconComponent > IconType for all available icons  */
  @Input() icon!: string;

  /** The size of the icon to be displayed, defaults to md. Check more sizes on IconComponent */
  @Input() size!: string;

  /** The spacing of the icon. */
  @Input() spacing!: string;

  /** The state of the icon */
  @Input() state!: string;

  /** The text to be displayed on the link */
  @Input() linkText!: string;

  /** The optional link url. This uses the href attribute */
  @Input() linkUrl!: string;

  @Input() linkRel!: string;

  /** The position of the icon relative to the link */
  @Input() iconPosition = IconPosition.Start;

  /** The target of the link. Uses target attribute */
  @Input() target: LinkTarget = LinkTarget.Self;

  /** The click event of the link */
  @Output() linkClicked = new EventEmitter();
}
